import c from "./_baseSlice.js";
function o(t, i, e) {
  var l = t.length;
  return e = e === void 0 ? l : e, !i && e >= l ? t : c(t, i, e);
}
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_castSlice.js
// module id = 1497
// module chunks = 67